export default "__VITE_ASSET__faefb18e__"